<template>
  <div style="padding-top: 150px">
    <!-- 导航 -->
    <mynav :lab="lab"></mynav>
    <!-- 轮播图 -->
    <el-carousel :height="imgHieght" arrow="always" :interval="5000">
      <el-carousel-item v-for="item in bannerList" :key="item">
        <img :src="item" alt="" width="100%" ref="image" @load="imgLoad" />
      </el-carousel-item>
    </el-carousel>
    <div class="business">
      <div class="business-inner business-inner-new-css-20230713">
        <div class="title">主营业务</div>
        <div class="business-content">
          <div
            v-for="(item, index) in busList"
            :key="index"
            class="business-item  business-item-new-css-20230713"
            @click="$router.push('/business/' + item.id)"
          >
            <div class="business-box business-box-new-css-20230713">
              <img :src="item.urls" alt="" width="100%" />
              <div class="item-text">
                <p class="item-title-20230713">{{ item.title }}</p>
                <p class="item-english-20230713">{{ item.english }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="more">
          <img
            src="../../assets/i/more/more_green.png"
            alt=""
            @click="mymore"
          />
        </div>
      </div>
    </div>
    <div class="dynamic">
      <div class="dynamic-inner">
        <div class="title">墣锦动态</div>
        <div class="dynamic-content">
          <div
            v-for="(item, index) in FrontCaseList"
            :key="index"
            @click="$router.push('/Udynamic/' + item.id)"
            class="dynamic-item"
          >
            <div class="dynamic-box" v-if="item.content.type">
              <div class="name">{{ item.name }}</div>
              <img :src="item.content.urlone" alt="" width="100%" />
              <div style="font-weight: bold">{{ item.content.title }}</div>
              <div class="text" v-html="item.content.content"></div>
              <div class="more">了解更多>></div>
            </div>
            <div class="dynamic-box" v-else>
              <div class="name">{{ item.name }}</div>
              <img :src="item.content[0].urlone" alt="" width="100%" />
              <div
                v-for="(items, indexs) in item.content"
                :key="indexs"
                style="color: #fff"
              >
                <div>
                  <i class="el-icon-link"></i>
                  {{ items.title }}--{{ items.time }}
                </div>
              </div>
              <div class="more">了解更多>></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="business">
      <div class="business-inner">
        <div class="title">经典案例</div>
        <div class="business-content case">
          <div  v-for="(item, index) in categoryList" :key="index" class="case-item">
            <div class="case-box"  @click="$router.push('/list/' + item.id)" >
              <div>
                  <img :src="item.cover" alt=""  />
              </div>
              <div class="case-text"> {{ item.title }} </div>
            </div>
          </div>
        </div>
<!--        <div class="more">-->
<!--          <img-->
<!--            src="../../assets/i/more/more_green.png"-->
<!--            alt=""-->
<!--            @click="$router.push('/Ucase')"-->
<!--          />-->
<!--        </div>-->
      </div>
    </div>
    <div style="padding-top: 40px">
      <myfooter></myfooter>
    </div>
  </div>
</template>
<script>
import mynav from "../../components/nav.vue";
import myfooter from "../../components/footer.vue";
import "../../assets/css/amazeui.min.css";
export default {
  data() {
    return {
      imgHieght: "300px",
      type: "",
      bannerList: "",
      busList: [],
      AllbusList: [],
      FrontCaseList: [],
      caseList: [],
      AllcaseList: [],
      lab: "",
      categoryList: []
    };
  },

  components: {
    mynav,
    myfooter,
  },
  watch: {
    $route() {
      this.lab = this.$route.query.lab || "ALL";
      this.getBanner();
      this.getBusiness();
      this.getCaseArt();
      this.getFrontCase();
    },
  },
  created() {
    this.lab = this.$route.query.lab || "ALL";
    this.getBanner();
    this.getBusiness();
    this.getCaseArt();
    this.getFrontCase();

  },
  mounted() {
    window.onresize = () => {
      this.imgLoad();
    };
    this.getCaseCategory();
  },
  methods: {
    // 获取全部的案例分类
    async getCaseCategory(){
      const rs = await this.$axios.get("/front/getCategoryList?is_delete=1")
      if( rs.code === 200 ) {
        this.categoryList = rs.data
      }
    },
    getBanner() {
      this.$axios.get("/front/getFrontBanner?lab=" + this.lab).then((res) => {
        this.bannerList = res.data;
      });
    },
    getBusiness() {
      let url = "/front/getFrontBusinessType";
      if (this.lab) {
        url = "/front/getFrontBusinessType?lab=" + this.lab;
      }
      this.$axios.get(url).then((res) => {
        this.AllbusList = res.data;
        this.busList = res.data.slice(0, 7);
      });
    },
    getCaseArt() {
      let url = "/front/getFrontCaseArt";
      if (this.lab) {
        url = "/front/getFrontCaseArt?lab=" + this.lab;
      }
      this.$axios.get(url).then((res) => {
        this.AllcaseList = res.data;
        this.caseList = res.data.slice(0, 6);
      });
    },
    getFrontCase() {
      let url = "/front/getFrontCase";
      if (this.lab) {
        url = "/front/getFrontCase?lab=" + this.lab;
      }
      this.$axios.get(url).then((res) => {
        this.FrontCaseList = [
          {
            name: "公司新闻",
            content: res.data[0],
            id: "news",
          },
          {
            name: "政策法规",
            content: res.data[1],
            id: "hotspot",
          },
          {
            name: "企业文化",
            content: res.data[2],
            id: "culture",
          },
          {
            name: "公示公告",
            id: "notice",
            content: [
              res.data[3],
              res.data[4],
              res.data[5],
              res.data[6],
              res.data[7],
            ],
          },
        ];
      });
    },
    imgLoad() {
      this.$nextTick(() => {
        this.imgHieght = this.$refs.image[0].height + "px";
      });
    },
    mymore() {
      if (this.busList == this.AllbusList) {
        this.busList = this.AllbusList.slice(0, 7);
      } else {
        this.busList = this.AllbusList;
      }
    },
  },
};
</script>
<style scoped lang="less">
.item-english-20230713{
  padding-right: 3px;
  font-size: 12px !important;
}
.item-title-20230713{
  font-weight: bold;
  font-size: 16px !important;
  line-height: 22px;
}
.business-box-new-css-20230713{
  width: 220px !important;
}
.business-inner-new-css-20230713{
  max-width: 1800px !important;
}
.business-item-new-css-20230713{
  width: 14% !important;
}
.business {
  width: 100%;
  background-color: #fff;
  margin: 40px 0;
  .business-inner {
    max-width: 1200px;
    margin: 0 auto;
    .title {
      width: 100%;
      text-align: center;
      font-size: 24pt;
      font-weight: 800;
      line-height: 100px;
      margin: 20px 0;
    }
    .business-content {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      padding: 20px 0;
      .business-item {
        display: flex;
        justify-content: center;
        // align-items: center;
        width: 16.666667%;
        .business-box {
          width: 190px;
          margin-bottom: 30px;
          position: relative;
          cursor: pointer;
          .item-text {
            font-size: 10pt;
            position: absolute;
            left: 40%;
            top: 13%;
            width: 60%;
            text-align: left;
            line-height: 14px;
            color: #fff;
          }
          .case-text {
            color: #808080;
            text-align: center;
            font-size: 11pt;
          }
        }
      }
    }
    .more {
      width: 100%;
      display: flex;
      justify-content: center;
      margin: 30px 0;
      cursor: pointer;
    }
  }
}
.dynamic {
  width: 100%;
  background-color: #32a0c8;
  margin-top: 30px;
  .dynamic-inner {
    max-width: 1200px;
    margin: 0 auto;
    .title {
      width: 100%;
      text-align: center;
      font-size: 24pt;
      font-weight: 800;
      line-height: 100px;
      color: #fff;
      margin: 20px 0;
    }
    .dynamic-content {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      padding: 20px 0;
      .dynamic-item {
        display: flex;
        justify-content: center;
        width: 25%;
        margin-bottom: 50px;
        cursor: pointer;
        .dynamic-box {
          width: 240px;
          color: #fff;
          img {
            margin-bottom: 10px;
          }
          .name {
            font-family: "Microsoft YaHei", sans-serif;
            font-size: 16pt;
            text-align: center;
            letter-spacing: 5px;
            font-weight: normal;
            margin-bottom: 10px;
          }
          .text {
            margin-top: 10px;
            height: 120px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .more {
            border: 1px solid #fff;
            font-size: 11pt;
            width: 118px;
            margin: 0 auto;
            margin-top: 20px;
            line-height: 32px;
            cursor: pointer;
          }
        }
      }
    }
    .more {
      width: 100%;
      display: flex;
      justify-content: center;
      cursor: pointer;
    }
  }
}
.case{
  justify-content: start;
  flex-wrap: wrap;
  cursor: pointer;
}
.case-item{
  width: 23% !important;
  height: 200px;
  margin-right: 20px;
}
.case-box{
  width: 100%;
  height: 200px;
}
.case-box>div{
  overflow: hidden;
  margin-bottom: 5px;
  height: 152px;

}
.case-box>div>img{
  height: 100%;
  width: 100%;
}
@media only screen and (max-width: 1025px) {
  .business {
    .business-inner {
      .business-content {
        .business-item {
          width: 33.33%;
        }
      }
    }
  }
  .dynamic {
    .dynamic-inner {
      .dynamic-content {
        .dynamic-item {
          width: 50%;
        }
      }
    }
  }
}

@media only screen and (max-width: 641px) {
  .business {
    .business-inner {
      .business-content {
        .business-item {
          width: 50%;
        }
      }
    }
  }
}
@media only screen and (max-width: 400px) {
  .business {
    .business-inner {
      .business-content {
        .business-item {
          width: 100%;
          padding: 0 30px;
          box-sizing: border-box;
          .business-box {
            width: 100%;
          }
        }
      }
    }
  }
  .dynamic {
    .dynamic-inner {
      .dynamic-content {
        .dynamic-item {
          width: 100%;
          padding: 0 30px;
          box-sizing: border-box;
          .dynamic-box {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
